// Room-based E2EE key types
// Each file acts as its own room: roomId = `${sessionId}::${filePath}`

export type RoomId = string;

export const makeRoomId = (sessionId: string, filePath: string): RoomId => `${sessionId}::${filePath}`;

// Local key material for a room (per user, per file)
export interface RoomKeyPair {
  roomId: RoomId;
  sessionId: string;
  filePath: string;
  userId: string;
  senderKeyId: string;
  chainKey: Uint8Array;
  nextMessageIndex: number;
  ed25519PrivateKey: Uint8Array;
  ed25519PublicKey: Uint8Array;
  x25519PrivateKey: Uint8Array;
  x25519PublicKey: Uint8Array;
}

// Remote participant sender key state for a room
export interface RoomRemoteKey {
  roomId: RoomId;
  sessionId: string;
  filePath: string;
  senderUserId: string;
  senderKeyId: string;
  chainKey: Uint8Array;
  lastMessageIndex: number;
  ed25519PublicKey: Uint8Array;
  x25519PublicKey?: Uint8Array;
}

export interface RoomParticipant {
  userId: string;
  name?: string;
  color?: string;
  ed25519PublicKey?: Uint8Array;
  x25519PublicKey?: Uint8Array;
}

export interface RoomKeyState {
  roomId: RoomId;
  local?: RoomKeyPair;
  remotes: Map<string, Map<string, RoomRemoteKey>>; // senderUserId -> senderKeyId -> key
}
